interface VisibleBlockedSlotMetricsParams {
  startTime: string
  endTime: string
  visibleStartHour: number
  totalHours: number
}

interface VisibleBlockedSlotMetrics {
  startMinutes: number
  durationMinutes: number
}

const MINS_PER_HOUR = 60

function toMinutes(time: string): number {
  const [hours = 0, minutes = 0] = time.split(':').map(Number)
  return hours * MINS_PER_HOUR + minutes
}

export function getVisibleBlockedSlotMetrics(
  params: VisibleBlockedSlotMetricsParams,
): VisibleBlockedSlotMetrics | null {
  const visibleStartMinutes = params.visibleStartHour * MINS_PER_HOUR
  const visibleEndMinutes = visibleStartMinutes + params.totalHours * MINS_PER_HOUR

  const clampedStartMinutes = Math.max(toMinutes(params.startTime), visibleStartMinutes)
  const clampedEndMinutes = Math.min(toMinutes(params.endTime), visibleEndMinutes)

  if (clampedEndMinutes <= clampedStartMinutes) {
    return null
  }

  return {
    startMinutes: clampedStartMinutes - visibleStartMinutes,
    durationMinutes: clampedEndMinutes - clampedStartMinutes,
  }
}
